module.exports = __webpack_public_path__ + "img/p-9-3.e118423e.png";